<template
  v-if="href"
  @mouseover.native="onOfficeHover(true)"
  @mouseleave.native="onOfficeHover(false)"
>
  <div :class="[name]">
    <a-heading
      v-if="cms.heading"
      html-tag="h4"
      :cms="cms"
      :class="`${name}__heading`"
    />
    <a-eyebrow v-if="cms.eyebrow" :cms="cms" :class="`${name}__eyebrow`" />
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="cms.copy"
      :class="`${name}__text`"
      v-html="$options.filters.markdown(cms.copy)"
    />
    <!--eslint-enable-->
    <component
      :is="item.component"
      v-for="item in cms.cta"
      :key="item._uid"
      v-editable="item"
      :cms="item"
      type="secondary"
      :class="`${name}__cta`"
    />
  </div>
</template>

<script>
import Href from '@/mixins/href'
import data from '~/components/molecules/m-cards/m-card-office.data'
import ACtaV2 from '~/components/atoms/a-ctas/a-cta-v2'

export default {
  components: { ACtaV2 },
  mixins: [Href],
  props: {
    cms: {
      type: Object,
      default() {
        return Object.assign(process.env.NODE_ENV === 'development' ? data : {})
      },
    },
  },
  data() {
    return {
      name: 'm-card-office',
    }
  },
  methods: {
    onOfficeHover(boolean) {
      this.$emit('onOfficeHover', {
        active: boolean || false,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-card-office {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  // overflow: hidden;
  display: grid;
  border: 1px solid $swirl;
  padding: 25px;

  ::v-deep a,
  ::v-deep .a-cta,
  ::v-deep .a-eyebrow {
    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
      border 0.2s ease-in-out;
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  &:hover {
    color: var(--bg-color);
    background: var(--text-color);

    ::v-deep a,
    ::v-deep .a-cta {
      color: var(--bg-color);
      &:hover,
      &:active {
        color: var(--hover-color);
      }
    }

    ::v-deep .a-eyebrow {
      color: var(--hover-color);
    }
  }

  &__text {
    word-break: break-all;
    overflow: hidden;
  }

  ::v-deep p {
    @include font-size(16, 28px);

    margin: 0 0 30px;
  }

  &__eyebrow {
    @include font-family($headings-font-family, 600);
    @include font-size(16, 28px);
  }

  &__cta {
    align-self: end;
  }
}

@include media-breakpoint-up(sm) {
  .m-card-office {
    padding: 50px;
  }
}

@include media-breakpoint-up(md) {
  .m-card-office {
    min-height: 418px;
  }
}
</style>
